"use strict";

angular.module('rmProgram', []);

require('./controller');
require('./resources');
require('./directives');
require('./routes');